
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SegmentFormAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attribute"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchBuilderAttribute"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SegmentFormSegmentBuilderSalesforceUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesforceUser"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":215}};
    doc.loc.source = {"body":"#import \"~/components/SearchBuilder/fragments.graphql\"\n\nfragment SegmentFormAttribute on Attribute {\n  ...SearchBuilderAttribute\n}\n\nfragment SegmentFormSegmentBuilderSalesforceUser on SalesforceUser {\n  id\n  name\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/components/SearchBuilder/fragments.graphql").definitions));


      module.exports = doc;
    
